import { FaPlus } from "react-icons/fa";

import {
  AddMyAddress,
  AddressList,
} from "../../index";

import styles from "./myaddress.module.css";

import {
  Loader,
} from "../../../../components/shared";

import {
  useState,
} from "react";

import {
  useDeleteUserAddressMutation,
  useUserAddressListQuery,
} from "../../../../queries/useUserAddress";

import Swal from "sweetalert2";

import {
  ErrorFallback,
  ErrorQueryBoundary,
} from "../../../../components";

import toast from "react-hot-toast";

import LocationPicker from "./AddMyAddress/Locationpicker";


const MyAddress = () => {

  /* =====================================================
     LOCATION POPUP
  ===================================================== */

  const [
    showLocationPicker,
    setShowLocationPicker,
  ] = useState(false);


  /* =====================================================
     FORM POPUP
  ===================================================== */

  const [
    showForm,
    setShowForm,
  ] = useState(false);


  /* =====================================================
     EDIT ADDRESS
  ===================================================== */

  const [
    editAddress,
    setEditAddress,
  ] = useState(null);


  /* =====================================================
     LOCATION DATA
  ===================================================== */

  const [
    locationData,
    setLocationData,
  ] = useState(null);


  /* =====================================================
     ADDRESS LIST
  ===================================================== */

  const {
    data: addressList = [],

    isPending,
  } =
    useUserAddressListQuery();


  /* =====================================================
     DELETE
  ===================================================== */

  const {
    mutate: deleteAddress,
  } =
    useDeleteUserAddressMutation();


  /* =====================================================
     DELETE ADDRESS
  ===================================================== */

  const handleDelete = (
    id
  ) => {

    Swal.fire({

      title:
        "Are you sure?",

      text:
        "You can't get it later!",

      icon:
        "warning",

      showCancelButton:
        true,

      confirmButtonText:
        "Yes, delete it!",

      cancelButtonText:
        "Cancel",

      confirmButtonColor:
        "#ff6b00",

      cancelButtonColor:
        "#777",

    }).then(
      (result) => {

        if (
          !result.isConfirmed
        ) {
          return;
        }


        deleteAddress(
          id,
          {
            onSuccess: () => {

              toast.success(
                "Address has been removed."
              );

            },

            onError: () => {

              toast.error(
                "Unable to remove address."
              );

            },
          }
        );

      }
    );
  };


  /* =====================================================
     ADD NEW ADDRESS
  ===================================================== */

  const handleAddAddress =
    () => {

      setEditAddress(
        null
      );

      setLocationData(
        null
      );

      /*
        FIRST:
        Show location picker.
      */

      setShowForm(
        false
      );

      setShowLocationPicker(
        true
      );
    };


  /* =====================================================
     LOCATION CONFIRMED
  ===================================================== */

const handleLocationConfirm = (selectedLocation) => {
  console.log(
    "LOCATION CONFIRMED:",
    selectedLocation
  );

  setLocationData({
    latitude: selectedLocation?.latitude ?? "",
    longitude: selectedLocation?.longitude ?? "",

    // This is ONLY for showing in "Delivery Location"
    address: selectedLocation?.address ?? "",

    // These will fill the form automatically
    city: selectedLocation?.city ?? "",
    zip: selectedLocation?.zip ?? "",

    state: selectedLocation?.state ?? "Telangana",
    country: selectedLocation?.country ?? "India",
  });

  setShowLocationPicker(false);
  setShowForm(true);
};


  /* =====================================================
     CHANGE LOCATION FROM FORM
  ===================================================== */

  const handleEditLocation =
    () => {

      /*
        Keep current
        locationData.

        This means when
        location popup opens,
        the current selected
        coordinates are available.
      */

      setShowForm(
        false
      );

      setShowLocationPicker(
        true
      );
    };


  /* =====================================================
     EDIT SAVED ADDRESS
  ===================================================== */

  const handleEditAddress =
    (item) => {

      setEditAddress(
        item
      );


      /*
        Convert saved
        address to location
        format.
      */

      setLocationData({

        latitude:
          item.latitude ||
          "",

        longitude:
          item.longitude ||
          "",

        address:
          item.address ||
          "",

        city:
          item.city ||
          "",

        zip:
          item.zip ||
          "",

        state:
          item.state_name ||
          "Telangana",

        country:
          item.country_name ||
          "India",

      });


      setShowLocationPicker(
        false
      );

      setShowForm(
        true
      );
    };


  /* =====================================================
     CLOSE FORM
  ===================================================== */

  const handleCloseForm =
    () => {

      setShowForm(
        false
      );

      setEditAddress(
        null
      );

      setLocationData(
        null
      );
    };


  /* =====================================================
     CLOSE LOCATION
  ===================================================== */

  const handleCloseLocation =
    () => {

      setShowLocationPicker(
        false
      );


      /*
        If form was not
        already open, clear
        temporary location.
      */

      if (!showForm) {

        setLocationData(
          null
        );

      }

    };


  return (
    <div
      className={
        styles.container
      }
    >

      {/* =================================================
          HEADER
      ================================================= */}

    {!showForm &&
  !showLocationPicker &&
  addressList.length > 0 && (
    <div className={styles.header}>
      <button
        type="button"
        className={styles.addBtn}
        onClick={handleAddAddress}
      >
        <FaPlus size={13} />
        <span>Add New Address</span>
      </button>
    </div>
  )}


      {/* =================================================
          SAVED ADDRESSES
      ================================================= */}

    {!showForm &&
  !showLocationPicker && (

  <div className={styles.addressContent}>

    <ErrorQueryBoundary
      fallback={
        <Loader title={"Loading user addresses.."} />
      }
      errorFallback={<ErrorFallback />}
    >

      {isPending ? (

        <Loader title={"Loading user addresses.."} />

      ) : addressList.length === 0 ? (

        /* ================================
           EMPTY ADDRESS STATE
        ================================= */

        <div className={styles.emptyAddressState}>

          <h2 className={styles.emptyAddressTitle}>
            Save Your Address
          </h2>

          <p className={styles.emptyAddressText}>
            Your saved addresses will appear here for faster checkout.
          </p>

          <button
            type="button"
            className={styles.emptyAddBtn}
            onClick={handleAddAddress}
          >
            <FaPlus size={13} />
            <span>Add New Address</span>
          </button>

        </div>

      ) : (

        /* ================================
           SAVED ADDRESSES
        ================================= */

        <AddressList
          addressList={addressList}
          onDelete={handleDelete}
          onEdit={handleEditAddress}
        />

      )}

    </ErrorQueryBoundary>

  </div>

)}


      {/* =================================================
          LOCATION PICKER
      ================================================= */}

      {showLocationPicker && (

        <LocationPicker

          onClose={
            handleCloseLocation
          }

          onConfirm={
            handleLocationConfirm
          }

          initialLocation={
            locationData
          }

        />

      )}


      {/* =================================================
          ADDRESS DETAILS FORM
      ================================================= */}

      {showForm && (

        <div
          className={
            styles.formOverlay
          }
        >

          <AddMyAddress

            mode={
              editAddress
                ? "edit"
                : "add"
            }

            initialData={
              editAddress
            }

            addressId={
              editAddress?.id
            }

            locationData={
              locationData
            }

            onEditLocation={
              !editAddress
                ? handleEditLocation
                : undefined
            }

            onClose={
              handleCloseForm
            }

          />

        </div>

      )}

    </div>
  );
};

export default MyAddress;